import { ReactElement } from "react";
import { ColoredValueModel } from "client/Api/Workspace/LiveInformation/Integration/integrationLiveInformation";
import { ListItem } from "client/Components";
import { ColoredText } from "./ColoredText";
import styles from "./Subtitles.module.less";

export type SubtitlesProps = {
	subTitle1: ColoredValueModel<string> | null;
	subTitle2: ColoredValueModel<string> | null;
	subTitle3: ColoredValueModel<string> | null;
};

export const Subtitles = (props: SubtitlesProps): ReactElement | null => {
	const {
		subTitle1,
		subTitle2,
		subTitle3
	} = props;

	if (
		!subTitle1?.value
			&& !subTitle2?.value
			&& !subTitle3?.value
	) {
		return null;
	}

	return (
		<ListItem.Row>
			<div className={styles.root}>
				{(subTitle1?.value || subTitle2?.value) && (
					<div className={styles.leftSide}>
						{subTitle1?.value && (
							<ListItem.SubTitle>
								<ColoredText
									trackingId="sub-title-1"
									color={subTitle1.color}
								>
									{subTitle1.value}
								</ColoredText>
							</ListItem.SubTitle>
						)}

						{subTitle2?.value && (
							<>
								{subTitle1?.value && (
									<span>|</span>
								)}

								<ListItem.SubTitle>
									<ColoredText
										trackingId="sub-title-2"
										color={subTitle2.color}
									>
										{subTitle2.value}
									</ColoredText>
								</ListItem.SubTitle>
							</>
						)}
					</div>
				)}
				{subTitle3?.value && (
					<div className={styles.rightSide}>
						<ListItem.SubTitle>
							<ColoredText
								trackingId="sub-title-3"
								color={subTitle3.color}
							>
								{subTitle3.value}
							</ColoredText>
						</ListItem.SubTitle>
					</div>
				)}
			</div>
		</ListItem.Row>
	);
};
Subtitles.displayName = "Subtitles";
